import { useMutation } from '@tanstack/react-query';
import { getAuthOptions } from '../services/auth.service';

type Variables = {
  email: string;
};

const useIsNewUser = () => {
  return useMutation<boolean, Error, Variables>({
    mutationFn: async ({ email }) => {
      const { accountStatus } = await getAuthOptions(email);
      return accountStatus.type === 'newUser';
    },
  });
};

export default useIsNewUser;
